import { Pipe, PipeTransform } from "@angular/core";

import { isSwitchFilterActive } from "@hermes/states/grid-filters-state";

@Pipe({
    name: "switchFilterChecked",
})
export class SwitchFilterCheckedPipe implements PipeTransform {
    public readonly transform = isSwitchFilterActive;
}
